import { List as AntdList, type ListProps } from 'antd';
import { ListItemProps } from 'antd/lib/list/Item';
import { ListItemMetaProps } from 'antd/lib/list/Item';

export const List = <T,>(props: ListProps<T>) => {
  return <AntdList {...props} />;
};

export const ListItem = (props: ListItemProps) => <AntdList.Item {...props} />;

export const ListItemMeta = (props: ListItemMetaProps) => (
  <AntdList.Item.Meta {...props} />
);
